import React from "react";
import menu from "../../data/menu.json";
import "./Menu-Preview.css";

const MenuPreview = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
     <div className="menu-banner">
      <div className="menu-banner-overlay">
        <h1 className="menu-banner-title">MENU</h1>
      </div>
    </div>
    <section className="services-section"> 
      {Object.entries(menu).map(([sectionKey, sectionData]) => (
        <div key={sectionKey} className="menu-category">
          <h2 className="category-title">{sectionData.gtitle || sectionKey}</h2>

          {sectionData.groups &&
            sectionData.groups.reduce((pairs, group, index, array) => {
              if (index % 2 === 0) {
                pairs.push(array.slice(index, index + 2));
              }
              return pairs;
            }, []).map((pair, pairIdx) => (
              <div className="menu-group-row" key={pairIdx} style={{ display: 'flex', gap: '40px' }}>
                {pair.map((group, groupIdx) => {
                  const isRowStyle = group.items.length > 2;

                  return (
                    <div key={groupIdx} className="menu-group" style={{ flex: 1 }}>
                      {group.group && (
                        <h3 className="group-title">{group.group}</h3>
                      )}
                      <div
                        className={
                          isRowStyle
                            ? "menu-items-horizontal"
                            : "menu-items-wrapper"
                        }
                      >
                        {group.items &&
                          group.items.map((item, idx) => (
                            <div
                              className={`menu-item ${
                                isRowStyle ? "horizontal-item" : ""
                              }`}
                              key={idx}
                            >
                              <div className="item-left">
                                <h4 className="item-name">{item.name}</h4>
                                {item.description && (
                                  <p className="item-description">
                                    {item.description}
                                  </p>
                                )}
                              </div>
                              <div className="item-right">
                                <span className="menu-price">{item.price}</span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}

          {sectionData.footnote && (
            <div className="section-footnote">
              <small>{sectionData.footnote}</small>
            </div>
          )}
        </div>
      ))}
    </section>
    </>
  );
};

export default MenuPreview;